import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import axios from 'axios';
import { DASHBOARD_EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  FETCH_ITEM_DETAILS_BEGIN,
  FETCH_ITEM_DETAILS_SUCCESS,
  FETCH_ITEM_DETAILS_FAILURE,
  FETCH_ITEM_DETAILS_DISMISS_ERROR,
} from './constants';

export function fetchItemDetails(payload = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_ITEM_DETAILS_BEGIN,
    });

const { itemNumber, siteNumber } = payload;
    const cognitoIdToken = getState().home.auth.cognitoIdToken;
    const token = `Bearer ${cognitoIdToken}`;


    const promise = axios({
      method: 'get',
      url: `${DASHBOARD_EXPORT_API_REQUEST_URL}/siap/item`,
      params: {
        itemNumber,
        siteNumber,
        _t: new Date().getTime(),
      },
      // headers: {
      //   'Authorization': token,
      // }

      headers: {
        'Authorization': token,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    })
      .then((res) => {
        // Check if the response status is 'success'
        if (res.data.status === 'success') {
          dispatch({
            type: FETCH_ITEM_DETAILS_SUCCESS,
            data: res.data.data,
          });
          return res.data.data 
      } else {
          // Handle 'fail' status from API (Response 1)
          const errorMessage = res.data.data?.message || 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: FETCH_ITEM_DETAILS_FAILURE,
            data: { error: errorMessage },
          });
          throw new Error(errorMessage);
        }
      })
      .catch((err) => {
        // Handle network errors or other exceptions
        // Response 2: err.response.data.description.data.message
        // Response 1: err.response.data.data.message
        const errorMessage = err?.response?.data?.description?.data?.message || 
                            err?.response?.data?.data?.message || 
                            err?.response?.data?.message ||
                            err?.message ||
                            'There is an error. Please refresh page or contact administrator.';
        
        dispatch({
          type: FETCH_ITEM_DETAILS_FAILURE,
          data: { error: errorMessage },
        });
        throw err;
      });

    return promise;
  };
}

export function dismissFetchItemDetailsError() {
  return {
    type: FETCH_ITEM_DETAILS_DISMISS_ERROR,
  };
}

export function useFetchItemDetails() {
  const dispatch = useDispatch();

  const { itemDetails, fetchItemDetailsPending, fetchItemDetailsError } = useSelector(
    state => ({
      itemDetails: state.iaSTIInquiry?.itemDetails,
      fetchItemDetailsPending: state.iaSTIInquiry?.fetchItemDetailsPending,
      fetchItemDetailsError: state.iaSTIInquiry?.fetchItemDetailsError,
    }),
    shallowEqual
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(fetchItemDetails(...args));
    },
    [dispatch]
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchItemDetailsError());
  }, [dispatch]);

  return {
    itemDetails,
    fetchItemDetails: boundAction,
    fetchItemDetailsPending,
    fetchItemDetailsError,
    dismissFetchItemDetailsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FETCH_ITEM_DETAILS_BEGIN:
      return {
        ...state,
        fetchItemDetailsPending: true,
        fetchItemDetailsError: null,
      };

    case FETCH_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        itemDetails: action.data,
        fetchItemDetailsPending: false,
        fetchItemDetailsError: null,
      };

    case FETCH_ITEM_DETAILS_FAILURE:
      return {
        ...state,
        fetchItemDetailsPending: false,
        fetchItemDetailsError: action.data.error,
      };

    case FETCH_ITEM_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        fetchItemDetailsError: null,
      };

    default:
      return state;
  }
}

